/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/prefer-default-export */
import debounce from 'lodash/debounce';

function brandSearchCallBack(phraseRaw) {
  const phrase = phraseRaw.trim().toLowerCase();
  const wrapper = document.querySelector('.js-brands-wrap');
  wrapper.querySelectorAll('dd a, dd span').forEach((elem) => {
    const brandName = elem.dataset.name?.toLowerCase() || 'no-brand';
    if (brandName.includes(phrase) || phrase.includes(brandName)) {
      elem.classList.remove('is-hidden');
    } else {
      elem.classList.add('is-hidden');
    }
  });
  wrapper.querySelectorAll('.brandletter').forEach((letter) => {
    if (letter.querySelector('a:not(.is-hidden), span:not(.is-hidden)')) {
      letter.classList.remove('isletter-hidden');
    } else {
      letter.classList.add('isletter-hidden');
    }
  });
  wrapper.classList.toggle('is-empty', !wrapper.querySelector('.brandletter:not(.isletter-hidden)'));
}

export function initBrandsSearch() {
  const input = document.querySelector('.js-brandsearch-input');
  if (!input) return;
  if (input.value) brandSearchCallBack(input.value);
  input.addEventListener('input', debounce((e) => brandSearchCallBack(e.target?.value), 100));
  const brandGetParam = (new URLSearchParams(window.location.search)).get('brand');
  if (brandGetParam) {
    input.value = encodeURI(brandGetParam);
    brandSearchCallBack(input.value);
  }
}
